import {
  CLEAR_ALL_ATTACHMENTS,
  REMOVE_ATTACHMENT,
  UPLOAD_ATTACHMENTS,
} from "../action.js";
import { transactionAttachments } from "./initial-store";

const initialState = transactionAttachments;

function transactionAttachmentsReducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_ATTACHMENTS: {
      const newFiles = action.payload?.filter(
        (file) =>
          !state
            .filter(
              (fileObj) =>
                fileObj.fileStatus && fileObj.fileStatus !== "DELETED"
            )
            .some((existingFile) => existingFile.fileName === file.fileName)
      );
      return [...newFiles, ...state];
    }

    case REMOVE_ATTACHMENT: {
      return state.map((file) =>
        file.fileName === action.payload
          ? { ...file, fileStatus: "DELETED" }
          : file
      );
    }

    case CLEAR_ALL_ATTACHMENTS: {
      return action.payload
        ? state.map((file) => ({ ...file, fileStatus: "DELETED" }))
        : [];
    }

    default:
      return state;
  }
}

export default transactionAttachmentsReducer;
